module.exports = __webpack_public_path__ + "static/media/Pause_icon.ed3b4234.svg";